import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const home = r => require.ensure([], () => r(require('./page/home/home.vue')), 'home')//首页
const login = r => require.ensure([], () => r(require('./page/login.vue')), 'login')//登录
const subscribe = r => require.ensure([], () => r(require('./page/subscribe.vue')), 'subscribe')//引导关注页面+
const cat = r => require.ensure([], () => r(require('./page/cat/cat.vue')), 'cat')//分类页面
const actList = r => require.ensure([], () => r(require('./page/activity/actList.vue')), 'actList') //着数列表
const mine = r => require.ensure([], () => r(require('./page/mine/mine.vue')), 'mine')//我的
const goods = r => require.ensure([], () => r(require('./page/goods/goods.vue')), 'goods') //商品详情
const collection = r => require.ensure([], () => r(require('./page/collection/collection.vue')), 'collection')//收藏列表
const orderList = r => require.ensure([], () => r(require('./page/order/list.vue')), 'orderList')//订单列表
const orderDet = r => require.ensure([], () => r(require('./page/order/detail.vue')), 'orderDet')//订单详情
const orderSubmit = r => require.ensure([], () => r(require('./page/order/submit.vue')), 'orderSubmit')//提交订单
const orderPaid = r => require.ensure([], () => r(require('./page/order/paid.vue')), 'orderPaid')//支付成功
const personal = r => require.ensure([], () => r(require('./page/mine/personal.vue')), 'personal')//个人信息

let routeObj = {login,subscribe,collection,orderList,orderDet,orderSubmit,orderPaid,personal};

const routes = [];

for (let name in routeObj ) {
    routes.push({path:`/${name}`,name,component:routeObj[name]});
}

routes.push({path:`/`,name:'home',component:home,meta: {isTab: true,tabIndex:0}});
routes.push({path:`/cat`,name:'cat',component:cat,meta: {isTab: true,tabIndex:1}});
routes.push({path:`/actList`,name:'actList',component:actList,meta: {isTab: true,tabIndex:2}});
routes.push({path:`/mine`,name:'mine',component:mine,meta: {isTab: true,tabIndex:3}});
routes.push({path:`/goods`,name:'goods',component:goods,meta: {keepAlive: true}});

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if(!to.name) return next({name:'home'})//输入错误地址转到首页
    if (['login','subscribe'].indexOf(to.name) > -1) {//非授权登陆页面，直接通过
        next();
    }else{//需要授权页面
        let toPath = encodeURIComponent(to.fullPath);
        let url = `${window.config.baseURL}wxLogin?path=${toPath}`;
        if(!localStorage.openId) return window.location.href = url;
        console.log('sessionStorage.goodsId ---》',sessionStorage.goodsId )
        if(to.name == 'orderSubmit'){//返回到下单页面的都重定向到商品详情页
            console.log('***************返回操作*****************')
            if(from.name == 'goods'){
                if(sessionStorage.goodsId == '0') return next();
                else return history.go(-2);
            }
           if(sessionStorage.goodsId){
               if(sessionStorage.goodsId == '0') {
                   next();
               } else {
                   next({name:'goods',query:{id:sessionStorage.goodsId}});
               }
           }else next();
        } else next();
    }
})

router.afterEach( (to, from) => {
    if (window.__wxjs_is_wkwebview) { // IOS
        if (!window.entryUrl) {
            window.entryUrl = to.fullPath
        }
    }else{
        window.entryUrl = to.fullPath
    }
})

export default router;